// extracted by mini-css-extract-plugin
module.exports = {"categoryContainer":"Category_categoryContainer__vcZZu","image":"Category_image__r1IeB","imageContainer":"Category_imageContainer__44Nql","label":"Category_label__Z7iyY"};